import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const createQuestionFavorite = questionId => postJson(`/questions/${questionId}/requirement-type-favorites`);

export const removeQuestionFavorite = questionId => deleteJson(`/questions/${questionId}/requirement-type-favorites`);

export const createQuestionCategoryFavorite = questionCategoryId => postJson(`/question-categories/${questionCategoryId}/requirement-type-favorites`);

export const removeQuestionCategoryFavorite = questionCategoryId => deleteJson(`/question-categories/${questionCategoryId}/requirement-type-favorites`);

export const markQuestionAnswerAsRead = (recordId, questionAnswerId) => putJson(`records/${recordId}/question-answers/${questionAnswerId}`);

export const editQuestionCategory = (questionCategoryId, name) => putJson(`/question-categories/${questionCategoryId}`, { name });

export const deleteQuestionCategory = questionCategoryId => deleteJson(`/question-categories/${questionCategoryId}`);

export const deleteQuestion = questionId => deleteJson(`/questions/${questionId}`);

export const editQuestion = (questionId, questionCategoryId, name, question, redFlag, retroactive) => putJson(`/questions/${questionId}`, {
  question_category_id: questionCategoryId,
  name,
  question,
  red_flag: redFlag,
  retroactive
});
